import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_leader_listing = async (
  source_slug = "",
  search = "",
  page = 0,
  limit = 20
) => {
  const requestObj = {
    path: `api/leaders/get_leaders?source_slug=${source_slug}&name=${search}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const leader_details = async (id) => {
  const requestObj = {
    path: `api/leaders/detail_leaders/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
